<template>
  <div class="row">
    <div v-if="completedRequest && requestStatusSuccess" class="col-sm-offset-3 col-sm-8 col-md-6">
      <div class="bs-callout bs-callout-sm bs-callout-success m-t-5">
        <p class="m-b-10">{{ $t('MESSAGE_HTTP_REQUEST_SUCCESS') }}</p>
        <p class="m-b-10 text-code">{{ completedRequestEndPoint }}</p>
        <div v-if="completedRequest && completedRequest.method === 'post'">
          <div class="m-b-10">{{ $t('HTTP_BODY') }}</div>
          <div class="prism-editor-wrapper no-radius m-t-5 m-b-15 f-s-12">
            <pre class="pre--basic">{{ JSON.parse(completedRequest.body) }}</pre>
          </div>
        </div>
        <span
          class="clickable text-underline m-b-10"
          @click="toggleResponse"
        >
          {{ $t('HTTP_VIEW_RESPONSE') }}
          <i
            class="fa fa-angle-right m-l-5"
            :class="{'fa-rotate-90': showRequestResponse}"
            aria-hidden="true"
          />
        </span>
        <collapse v-model="showRequestResponse">
          <div class="prism-editor-wrapper no-radius m-t-10 f-s-12">
            <pre class="pre--basic">{{ requestResponseBody }}</pre>
          </div>
        </collapse>
      </div>
    </div>
    <div v-if="completedRequest && requestStatusFail" class="col-sm-offset-3 col-sm-8 col-md-6">
      <div class="bs-callout bs-callout-sm bs-callout-danger m-t-5">
        <p>{{ $t('MESSAGE_HTTP_REQUEST_FAILED') }}</p>
        <div
          v-if="requestError"
          class="m-t-10"
        >
          <span
            class="clickable text-underline m-b-10"
            @click="toggleError"
          >
            {{ $t('HTTP_VIEW_ERROR') }}
            <i
              class="fa fa-angle-right m-l-5"
              :class="{'fa-rotate-90': showRequestError}"
              aria-hidden="true"
            />
          </span>
          <collapse v-model="showRequestError">
            <div class="prism-editor-wrapper no-radius m-t-10 f-s-12">
              <pre class="pre--basic">{{ errorCodeHelpText }} {{ requestResponseBody }}</pre>
            </div>
          </collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { STATUS_SUCCESS, STATUS_PENDING, STATUS_ERROR } from '@/store/helpers';
import sharedMessages from '@/core/locales';

export default {
  name: 'HttRequestResponse',
  props: {
    requestResponseBody: {
      type: Object,
      default() {
        return null;
      },
    },
    completedRequest: {
      type: Object,
      default() {
        return null;
      },
    },
    requestError: {
      type: String,
      default: ''
    },
    requestStatus: {
      type: String,
      default: ''
    },
    requestResponseCode: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      showRequestResponse: false,
      showRequestError: false
    }
  },
  computed: {
    requestStatusLoading() {
      return this.requestStatus == STATUS_PENDING;
    },
    requestStatusSuccess() {
      return this.requestStatus == STATUS_SUCCESS;
    },
    requestStatusFail() {
      return this.requestStatus == STATUS_ERROR;
    },
    completedRequestEndPoint() {
      return `${this.completedRequest?.method.toUpperCase()} ${this.completedRequest.url}`;
    },
    errorCodeHelpText() {
      return `${this.$i18n.t('ERROR_CODE_TEXT')}: ${this.requestResponseCode}\n\n`;
    }
  },
  methods: {
    toggleResponse() {
      this.showRequestResponse = !this.showRequestResponse;
    },
    toggleError() {
      this.showRequestError = !this.showRequestError;
    },
  },
  i18n: {
    sharedMessages,
    locale: 'en'
  } 
};
</script>